import Vue from 'vue'
import router from '../router'
import { getCookie, setCookie, clearCookie } from './cookie.js'
import { Post, Get } from '@/libs/http'
import Config from '@/libs/config'
import { apiCommonInfo } from '@/api/index'
import store from '@/store/index.js'
import { getVideo } from '@/api'

// 常量定义
export const FILE_TYPE = {
  IMAGE: 1, // 图片
  DOCUMENT: 2, // 文档
  AUDIO: 3, // 音频
  VIDEO: 4 // 视频
}
export const FILE_TYPE_INFO = {
  [FILE_TYPE.IMAGE]: {
    fileType: FILE_TYPE.IMAGE,
    typeAlias: [
      'image',
      'image/jpg',
      'image/jpeg',
      'image/png',
      'image/gif',
      'jpg',
      'jpeg',
      'png',
      'gif'
    ],
    name: '图片',
    icon: 'mdi-image',
    color: 'green'
  },
  [FILE_TYPE.DOCUMENT]: {
    fileType: FILE_TYPE.DOCUMENT,
    typeAlias: ['document', 'application/pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'],
    name: '文档',
    icon: 'mdi-file-pdf-box',
    color: 'red'
  },
  [FILE_TYPE.AUDIO]: {
    fileType: FILE_TYPE.AUDIO,
    typeAlias: ['audio', 'audio/mpeg', 'audio/wav', 'audio/x-wav', 'mp3', 'wav'],
    name: '音频',
    icon: 'mdi-music-note',
    color: 'blue'
  },
  [FILE_TYPE.VIDEO]: {
    fileType: FILE_TYPE.VIDEO,
    typeAlias: ['video', 'video/mp4', 'video/webm', 'video/ogg', 'mp4', 'm4v', 'webm', 'ogg'],
    name: '视频',
    icon: 'mdi-video',
    color: 'purple'
  }
}
export async function downloadResourceVideo(vid, name) {
  const [err, res] = await to(getVideo(vid))
  if (err || !res || !res.mp4PlayUrl) {
    Vue.prototype.$notice('获取视频地址失败')
    return
  }
  return downloadResource(res.mp4PlayUrl, name)
}
export function downloadResource(url, name) {
  // 检查参数
  if (!url || !name) {
    Vue.prototype.$notice('下载参数错误，请检查资源地址和文件名')
    return
  }

  // 方法1: 使用fetch强制下载
  fetch(url)
    .then(response => {
      return response.blob()
    })
    .then(blob => {
      // 创建blob URL
      const blobUrl = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = blobUrl
      link.download = name
      link.style.display = 'none'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      // 清理blob URL
      window.URL.revokeObjectURL(blobUrl)
    })
    .catch(error => {
      console.error(error, '默认链接下载')
      const link = document.createElement('a')
      link.href = url
      link.download = name
      link.target = '_blank'
      link.style.display = 'none'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    })
}

export function GetQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  var r = window.location.search.substr(1).match(reg)
  if (r != null) {
    return unescape(r[2])
  }
  return null
}
export function Error(data) {
  let _msg
  if (data && data.code) {
    switch (data.code) {
      case 900006:
        _msg = '登录超时，请重新登录'
        SetLogout()
        break
      case 4008:
        _msg = '旧密码与新密码不可一致，请重新输入'
        break
      case 9999:
        _msg = '网络异常，请重试'
        break
      case 4006:
        _msg = '用户名或密码错误'
        SetLogout()
        break
      case 8999:
        _msg = ''
        SetLogout()
        break

      default:
        _msg = data ? data.msg || data.message || '错误' : '错误'
    }
  }
  if (_msg) {
    Vue.prototype.$notice(_msg)
  }
}
// 验证用户是否登录
export function CheckLogin() {
  let _telnum = getCookie('telnum')
  let _credential = getCookie('credential')
  const _userBasicInfo = getUserBasicInfo()
  store.state.UserBasicInfo = _userBasicInfo
  // 将缓存的电话号码和用户凭证数据放入vuex中
  store.state.Telnum = _telnum
  store.state.Credential = _credential
  return _telnum && _credential
}

export function CheckStatus(callback) {
  let _user = getCookie('user') ? JSON.parse(getCookie('user')) : null
  switch (_user.status) {
    case 1:
      router.push('/passwordChange')
      break
    case 2:
      if (callback) {
        callback()
      }
      break
    case 3:
      alert('该用户已失效, 请联系发卡机构')
      break
  }
}
export function SetLogin(data) {
  if (data) {
    const { id, name, telnum, gardenId, credential, roles, enableWatermark } = data
    store.state.Credential = credential
    setCookie('credential', credential)
    store.state.Telnum = telnum
    setCookie('telnum', telnum)
    localStorage.setItem(
      'user_basic_info',
      JSON.stringify({ id, name, gardenId, telnum, roles, enableWatermark })
    )
    store.state.UserBasicInfo = data
  }
}
export function SetLogout() {
  store.state.Credential = null
  store.state.Telnum = null
  localStorage.removeItem('user_basic_info')
  clearCookie()
  router.replace({
    path: '/login'
  })
}
export function GetCourse(callback) {
  Post('/web/course/opt', {
    opt: 2
  })
    .then(res => {
      store.state.Course = res.data
      StorePlayerAuth()
      if (callback) {
        callback()
      }
      return
    })
    .catch(err => {
      Error(err)
    })
}
export function GetCourseList() {
  return Post('/web/course/opt', {
    opt: 3
  })
    .then(res => {
      return res
    })
    .catch(err => {
      Error(err)
    })
}
export function SendState(data) {
  switch (data.page) {
    case 'createApp':
      data.type = 11
      break
    case 'destroyApp':
      data.type = 12
      break
    case 'index':
      data.type = 1
      break
    case 'group':
      data.type = 2
      break
    case 'step':
      data.type = 3
      break
    case 'part':
      data.type = 4
      break
  }
  // Post('/api/stat/send', data).then(() => {
  // }).catch(() => {
  // })
}
export function GetGroup() {
  Post('/web/group/opt', {
    opt: 1,
    themeId: store.state.CourseActive[1]
  })
    .then(res => {
      store.state.Group = res.data
    })
    .catch(err => {
      Error(err)
    })
}
export function stopPlayer() {
  let _player = document.getElementById('J_prismPlayer')
  if (_player) {
    _player.remove()
  }
}
// eslint-disable-next-line no-unused-vars
export function GetPartList(type, callback) {
  console.log('store.state.CourseActive:', store.state.CourseActive)
  console.log('store.state.MenuActive:', store.state.MenuActive)

  if (!store.state.CourseActive[1] || !store.state.MenuActive[1]) {
    return
  }
  let _data
  if (type == 'p') {
    _data = {
      opt: 2,
      courseId: store.state.CourseActive[0],
      themeId: store.state.CourseActive[1],
      partType: store.state.MenuActive[1]
    }
  }
  if (type == 'g') {
    _data = {
      opt: 1,
      courseId: store.state.CourseActive[0],
      groupId: store.state.MenuActive[1]
    }
  }
  if (!_data) {
    return
  }
  // Post('/web/step/opt', _data)
  //   .then(res => {
  //     store.state.PartList = res.data || []
  //     if (callback) {
  //       callback()
  //     }
  //   })
  //   .catch(err => {
  //     Error(err)
  //   })
}
export function SetActive(courseIndex, menuIndex, callback) {
  let course = store.state.Course
  let menu
  // let index = 0
  courseOutter: for (var i = 0; i < course.length; i++) {
    for (var j = 0; j < course[i].list.length; j++) {
      if (course[i].list[j].themeId == courseIndex) {
        store.state.CourseActive = [course[i].madyCourse.courseId, course[i].list[j].themeId]
        GetGroup()
        if (menuIndex.split('-')[0] == 'g') {
          store.state.MenuActive = [1, menuIndex.split('-')[1]]
          if (callback) {
            callback()
          }
        }
        if (course[i].madyCourse.type == 2) {
          SetMenu(course[i].madyCourse.type)
          return
        }
        menu = Config.defaultMenu
        store.state.Menu = menu
        if (menuIndex.split('-')[0] == 'p') {
          if (menuIndex.split('-')[1] == 323334) {
            store.state.MenuActive = [323334, 323334]
            if (callback) {
              callback()
            }
          } else {
            menuOutter: for (let i = 0; i < menu.length; i++) {
              if (!menu[i].list) {
                continue menuOutter
              }
              for (let j = 0; j < menu[i].list.length; j++) {
                if (menu[i].list[j].partType == menuIndex.split('-')[1]) {
                  store.state.MenuActive = [menu[i].gatherId, menu[i].list[j].partType]
                  if (callback) {
                    callback()
                  }
                  break menuOutter
                }
              }
            }
          }
        }
        break courseOutter
      }
    }
  }
}
export function SetMenu(type) {
  // type:1,defaultMenu.2,null
  if (type == 1) {
    store.state.Menu = Config.defaultMenu
  } else if (type == 2) {
    store.state.Menu = null
  }
}
export function GetSrt(url, callback) {
  Get(url)
    .then(() => {})
    .catch(err => {
      if (callback) {
        callback(parseSrtSubtitles(err))
      }
    })
}

function parseSrtSubtitles(srt) {
  var subtitles = []
  srt = String(srt)
  var textSubtitles = srt.split('\r\n\r\n') // 每条字幕的信息，包含了序号，时间，字幕内容
  for (var i = 0; i < textSubtitles.length; i++) {
    var textSubtitle = textSubtitles[i].split('\r\n')
    for (var j = 0; j < textSubtitle.length; j++) {
      if (textSubtitle[j] == '') {
        textSubtitle.splice(j, 1)
      }
    }
    if (textSubtitle.length >= 2) {
      var sn = textSubtitle[0] // 字幕的序号
      var startTime = toSeconds(textSubtitle[1].split(' --> ')[0].trim()) // 字幕的开始时间
      var endTime = toSeconds(textSubtitle[1].split(' --> ')[1].trim()) // 字幕的结束时间
      var chinese = textSubtitle[2] || '' // 字幕的内容
      var english = textSubtitle[3] || '' // 字幕的内容
      // 字幕对象
      var subtitle = {
        sn: sn,
        startTime: startTime,
        endTime: endTime,
        chinese: chinese,
        english: english
      }
      subtitles.push(subtitle)
    }
  }
  return subtitles
}

/**
 * 把字符串格式的字幕时间转换为浮点数
 *
 * @param  string t 字符串格式的时间
 * @return 浮点数格式的时间
 */
function toSeconds(t) {
  var s = 0.0

  if (t) {
    var p = t.split(':')
    for (var i = 0; i < p.length; i++) {
      s = s * 60 + parseFloat(p[i].replace(',', '.'))
    }
  }
  return s
}
import youxituya from '../assets/img/part_type_youxituya.png'
import woderenzhishu from '../assets/img/part_type_woderenzhishu.png'
import woyaoshangyoueryuan from '../assets/img/part_type_woyaoshangyoueryuan.png'
import wodehuiben from '../assets/img/part_type_wodehuiben.png'
import tuozhangequ from '../assets/img/part_type_tuozhangequ.png'
import waijiaodaoxue from '../assets/img/part_type_waijiaodaoxue.png'
import shouyujiaoxue from '../assets/img/part_type_shouyujiaoxue.png'
import siwiexunlian from '../assets/img/part_type_siwiexunlian.png'
import shougongyouxi from '../assets/img/part_type_shougongyouxi.png'
import gequdaoxue from '../assets/img/part_type_gequdaoxue.png'
import gequxinshang from '../assets/img/part_type_gequxinshang.png'
import fuxigequ from '../assets/img/part_type_fuxigequ.png'
import gequbiaoyan from '../assets/img/part_type_gequbiaoyan.png'
import danciyouxi from '../assets/img/part_type_danciyouxi.png'
import dancigendu from '../assets/img/part_type_dancigendu.png'
import pfSiweidaotu from '../assets/img/pf_type_siweidaotu.png'
import pfShouyuxuexi from '../assets/img/pf_type_shouyuxuexi.png'
import pfDancixuexi from '../assets/img/pf_type_dancixuexi.png'
import pfGequxuexi from '../assets/img/pf_type_gequxuexi.png'
import pfQuweituya from '../assets/img/pf_type_quweituya.png'

// import dancishijian from '../assets/img/part_type_dancishijian.png'
// import pindudaoxue from '../assets/img/part_type_pindudaoxue.png'
// import pindufuxi from '../assets/img/part_type_pindufuxi.png'
// import pindugeyao from '../assets/img/part_type_pindugeyao.png'
// import pindugushi from '../assets/img/part_type_pindugushi.png'
// import pindulianxi from '../assets/img/part_type_pindulianxi.png'
// import pinduyouxi from '../assets/img/part_type_pinduyouxi.png'
// import zimuyouxi from '../assets/img/part_type_zimuyouxi.png'
// import zipingendu from '../assets/img/part_type_zipingendu.png'

// import pfPindulianxi from '../assets/img/pf_type_pindulianxi.png'
// import pfCikazhanshi from '../assets/img/pf_type_cikazhanshi.png'
// import pfDancilianxi from '../assets/img/pf_type_dancilianxi.png'
// import pfGushixuexi from '../assets/img/pf_type_gushixuexi.png'
import imageDefault from '@/assets/img/image_default.png'

export function ChangePartPic(type) {
  let pic
  switch (type + '') {
    case '21':
      pic = dancigendu
      break
    case '22':
      pic = gequxinshang
      break
    case '23':
      pic = gequdaoxue
      break
    case '24':
      pic = gequbiaoyan
      break
    case '25':
      pic = fuxigequ
      break
    case '26':
      pic = danciyouxi
      break
    case '27':
      pic = shougongyouxi
      break
    case '28':
      pic = youxituya
      break
    case '29':
      pic = waijiaodaoxue
      break
    case '30':
      pic = shouyujiaoxue
      break
    case '31':
      pic = tuozhangequ
      break
    case '32':
      pic = woderenzhishu
      break
    case '33':
      pic = wodehuiben
      break
    case '34':
      pic = woyaoshangyoueryuan
      break
    case '38':
      pic = dancigendu
      break
    case '39':
      pic = siwiexunlian
      break
    case '10001':
      pic = pfShouyuxuexi
      break
    case '10002':
      pic = pfDancixuexi
      break
    case '10003':
      pic = pfGequxuexi
      break
    case '10004':
      pic = pfSiweidaotu
      break
    case '10005':
      pic = pfQuweituya
      break
    default:
      pic = imageDefault
  }
  return pic
}

export function ChangeUrl(url) {
  if (!url) {
    return ''
  }
  url = url.replace('http://', 'https://')
  return url
}
export function ChangeGroupName(type) {
  let name
  switch (type + '') {
    // case '1':
    //     name = '学习'
    //     break
    case '2':
      name = '复习'
      break
    case '6':
      name = '自拼课'
      break
    case '7':
      name = '周复习'
      break
    case '8':
      name = '双周复习'
      break
    case '10':
      name = '月复习'
      break
    case '100':
      name = '总复习'
      break
    case '99':
      name = '测评课'
      break
    default:
      name = ''
  }
  return name
}
export function GetUuid32() {
  return 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

export function StorePlayerAuth() {
  // Post('/web/video/sts', {
  // }).then(res => {
  //     store.state.PlayAuth = res.data
  //     setInterval(StorePlayerAuth, res.data.expiration * 100);
  //     return
  // }).catch(err => {
  //     Error(err)
  // })
}

// Promise 错误处理工具函数，返回 [err, data] 形式
export function to(promise, errorExt) {
  return promise
    .then(function (data) {
      return [null, data]
    })
    .catch(function (err) {
      if (errorExt) {
        var parsedError = Object.assign({}, err, errorExt)
        return [parsedError, undefined]
      }
      return [err, undefined]
    })
}

export async function resetServerTimeOffset() {
  const [err, res] = await to(apiCommonInfo({}))
  if (err) {
    Error(err)
    return
  }
  const serverTime = res?.timestamp || 0
  const localTime = Date.now()
  store.state.serverTimeOffset = serverTime - localTime
  return serverTime - localTime
}

// 水印
export function addWatermark(str, wrapperSelector = '.watermark-wrapper') {
  // 参数常量
  const SCROLL_ID = 'scroll-watermark'
  const BG_ID = 'super-watermark'
  const STYLE_ID = 'scroll-watermark-style'
  const SCROLL_TEXT = '本页面为内部资料，严禁拍照、截屏、外传，违者将依法追究责任。'
  const SCROLL_HEIGHT = 40
  const SCROLL_FONT = 'bold 26px Arial'
  const SCROLL_COLOR = 'rgba(83,23,23,0.15)'
  const SCROLL_ANIM = 'scroll-watermark-anim 18s linear infinite'
  const SCROLL_INTERVAL = 10000
  const FADE_DURATION = 600
  const C_WIDTH = window.innerWidth
  const C_HEIGHT = window.innerHeight

  // 生成背景水印canvas
  const canvas = document.createElement('canvas')
  canvas.width = C_WIDTH
  canvas.height = C_HEIGHT
  const ctx = canvas.getContext('2d')
  ctx.fillStyle = 'rgb(239,9,9)'
  ctx.translate(canvas.width / 2, canvas.height / 2)
  ctx.rotate(-Math.PI / 6)
  ctx.textAlign = 'center'
  ctx.textBaseline = 'middle'
  const A_X = -Math.floor(C_WIDTH * 0.12)
  const A_Y = -Math.floor(C_HEIGHT * 0.3)
  const B_X = -Math.floor(C_WIDTH * 0.15)
  const B_Y = Math.floor(C_HEIGHT * 0.1)
  const C_X = Math.floor(C_WIDTH * 0.23)
  const C_Y = Math.floor(C_HEIGHT * 0.15)

  ctx.font = '56px Arial'
  ctx.fillText('备 课 专 用', A_X, A_Y)
  ctx.fillText('备 课 专 用', B_X, B_Y)
  ctx.fillText('备 课 专 用', C_X, C_Y)
  ctx.font = '30px Arial'
  ctx.fillText(str, A_X, A_Y + 40)
  ctx.fillText(str, B_X, B_Y + 40)
  ctx.fillText(str, C_X, C_Y + 40)

  const wrapper = document.querySelector(wrapperSelector)
  if (!wrapper) return

  // 清理旧水印
  const oldBg = document.getElementById(BG_ID)
  if (oldBg) oldBg.remove()
  const oldScroll = document.getElementById(SCROLL_ID)
  if (oldScroll) oldScroll.remove()

  // 背景水印DOM
  const bgWm = document.createElement('div')
  bgWm.id = BG_ID
  bgWm.setAttribute('data-watermark', 'true')
  Object.assign(bgWm.style, {
    pointerEvents: 'none',
    position: 'fixed',
    left: 0,
    top: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 99999,
    userSelect: 'none',
    backgroundImage: `url(${canvas.toDataURL('image/png')})`,
    opacity: 1
  })
  wrapper.appendChild(bgWm)

  // 滚动水印DOM
  function createScrollWatermark() {
    const scrollWm = document.createElement('div')
    scrollWm.id = SCROLL_ID
    scrollWm.setAttribute('data-watermark', 'true')
    Object.assign(scrollWm.style, {
      position: 'fixed',
      left: 0,
      width: '100vw',
      height: SCROLL_HEIGHT + 'px',
      zIndex: 100000,
      pointerEvents: 'none',
      userSelect: 'none',
      overflow: 'hidden',
      background: 'transparent',
      opacity: 1,
      transition: `opacity ${FADE_DURATION / 1000}s`
    })
    const scrollText = document.createElement('div')
    scrollText.innerText = SCROLL_TEXT
    Object.assign(scrollText.style, {
      display: 'inline-block',
      whiteSpace: 'nowrap',
      font: SCROLL_FONT,
      color: SCROLL_COLOR,
      textShadow: '0 1px 2px #fff, 0 -1px 2px #fff',
      lineHeight: SCROLL_HEIGHT + 'px',
      paddingLeft: '100vw',
      animation: SCROLL_ANIM
    })
    scrollWm.appendChild(scrollText)
    wrapper.appendChild(scrollWm)
    return scrollWm
  }

  // 注入动画样式
  if (!document.getElementById(STYLE_ID)) {
    const style = document.createElement('style')
    style.id = STYLE_ID
    style.innerHTML = `@keyframes scroll-watermark-anim { 0% { transform: translateX(0); } 100% { transform: translateX(-100vw); } }`
    document.head.appendChild(style)
  }

  // 随机位置+渐显渐隐
  function setRandomPositionWithFade(scrollWm) {
    scrollWm.style.opacity = '0'
    setTimeout(() => {
      const vh = window.innerHeight
      const top = Math.floor(Math.random() * (vh - SCROLL_HEIGHT))
      scrollWm.style.top = top + 'px'
      scrollWm.style.opacity = '1'
    }, FADE_DURATION)
  }

  // 创建并初始化滚动水印
  const scrollWm = createScrollWatermark()
  setRandomPositionWithFade(scrollWm)
  if (window._scrollWatermarkTimer) clearInterval(window._scrollWatermarkTimer)
  window._scrollWatermarkTimer = setInterval(() => {
    setRandomPositionWithFade(scrollWm)
  }, SCROLL_INTERVAL)
}

export function getUserBasicInfo(key = null) {
  const info = JSON.parse(localStorage.getItem('user_basic_info')) || {}
  if (!key) {
    return info
  }
  return info[key] || null
}
